/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IEngagementsOrdersByPeriodItem } from 'pages/Dashboard/Dashboard.models';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { getEngagementsOrdersTOMrc } from './api.service';

export interface IState {
  data: IEngagementsOrdersByPeriodItem[];
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: [],
  error: null,
  isLoading: false,
};

export const getEngagementsOrdersTOMrcAction = createAsyncThunk(
  'getEngagementsOrdersTOMrcAction',
  async (
    { controller, params }: {params: TPeriod, controller: AbortController},
    { rejectWithValue },
  ) => {
    const { signal } = controller;

    try {
      const { data } = await getEngagementsOrdersTOMrc(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const EngagementsOrdersTOMrcSlice = createSlice({
  name: 'getEngagementsOrdersTOMrcSlice',
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getEngagementsOrdersTOMrcAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEngagementsOrdersTOMrcAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getEngagementsOrdersTOMrcAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = [];
      });
  },
});

export const { clear: clearEngagementsOrdersTOMrcAction } = EngagementsOrdersTOMrcSlice.actions;

export const getEngagementsOrdersTOMrcReducer = EngagementsOrdersTOMrcSlice.reducer;
